<script lang="ts" setup>
import type { IconStyleType } from '@/api/interfaces'

interface Props {
  iconStyle: IconStyleType
}

defineProps<Props>()
</script>

<template>
  <svg
    v-if="iconStyle === 'isometric'"
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="149"
    viewBox="0 0 90 149"
    fill="none"
  >
    <g id="Frame" clip-path="url(#clip0_5776_102133)">
      <g id="Group">
        <g id="Layer 2">
          <g id="Group_2">
            <path
              id="Vector"
              d="M24.9872 60.8691C24.3781 60.8691 23.769 60.7092 23.2035 60.3892C9.58599 52.5071 -2.63927 30.955 0.493183 8.53034C1.08777 4.24027 3.68364 2.55333 5.17736 1.928C12.4284 -1.11141 24.9582 7.59961 28.6272 10.3336C30.208 11.5261 30.5415 13.7657 29.3524 15.3654C28.1777 16.9505 25.9299 17.285 24.3346 16.107C17.8667 11.2789 10.0356 7.68687 7.93276 8.57396C7.78774 8.63213 7.64272 9.12658 7.58471 9.53378C4.62628 30.6933 17.2866 48.6824 26.771 54.165C28.4822 55.1539 29.0768 57.3498 28.0762 59.0804C27.4091 60.2293 26.2054 60.8837 24.9727 60.8837L24.9872 60.8691Z"
              fill="url(#paint0_linear_5776_102133)"
            />
            <path
              id="Vector_2"
              d="M89.9998 122.327V110.097L88.3901 110.199C88.0566 109.908 87.665 109.632 87.2299 109.385L56.8771 91.8025C53.179 89.6648 47.2042 89.6648 43.5061 91.8025L8.07752 112.468C7.75847 112.642 7.48293 112.846 7.2364 113.035L5.30762 113.151V125.352C5.30762 125.352 5.30762 125.41 5.30762 125.44V125.541C5.36563 126.894 6.27926 128.232 8.06301 129.264L38.4159 146.832C42.1139 148.969 48.0888 148.969 51.7868 146.832L87.2154 126.167C88.9702 125.149 89.8838 123.825 89.9708 122.502V122.298L89.9998 122.327Z"
              fill="url(#paint1_linear_5776_102133)"
            />
            <path
              id="Vector_3"
              d="M87.2299 113.95L51.8012 134.615C48.1032 136.753 42.1283 136.753 38.4448 134.615L8.09191 117.033C6.09062 115.885 5.19149 114.329 5.35102 112.816C5.48154 111.536 6.39517 110.271 8.09191 109.297L43.5205 88.6463C47.2041 86.5085 53.1934 86.5085 56.877 88.6463L87.2299 106.214C88.9266 107.188 89.8257 108.453 89.9707 109.733C90.1448 111.245 89.2311 112.802 87.2299 113.95Z"
              fill="#30BFBF"
            />
            <path
              id="Vector_4"
              d="M89.9713 109.733C89.8263 111.013 88.9271 112.278 87.2304 113.238L51.8018 133.903C48.1037 136.041 42.1289 136.041 38.4453 133.903L8.09246 116.321C6.39571 115.346 5.49658 114.081 5.35156 112.816C5.48208 111.536 6.39571 110.271 8.09246 109.297L43.5211 88.6463C47.2046 86.5085 53.194 86.5085 56.8775 88.6463L87.2304 106.214C88.9271 107.188 89.8263 108.453 89.9713 109.733Z"
              fill="url(#paint2_linear_5776_102133)"
            />
            <path
              id="Vector_5"
              d="M77.5712 110.562V101.909L76.4401 101.982C76.208 101.778 75.9325 101.589 75.6135 101.4L54.1359 88.9664C51.5255 87.4539 47.2909 87.4539 44.6805 88.9664L19.6209 103.582C19.4033 103.713 19.2003 103.843 19.0263 103.989L17.6631 104.076V112.7C17.6631 112.7 17.6631 112.744 17.6631 112.758V112.831C17.7066 113.791 18.3592 114.736 19.6064 115.463L41.084 127.897C43.6943 129.409 47.929 129.409 50.5393 127.897L75.599 113.282C76.8461 112.554 77.4842 111.624 77.5422 110.678V110.533L77.5712 110.562Z"
              fill="url(#paint3_linear_5776_102133)"
            />
            <path
              id="Vector_6"
              d="M75.614 104.644L50.5544 119.259C47.944 120.771 43.7094 120.771 41.0991 119.259L19.6215 106.825C18.2148 106.011 17.5622 104.905 17.6782 103.844C17.7797 102.942 18.4178 102.055 19.6215 101.357L44.6811 86.7417C47.2915 85.2293 51.5261 85.2293 54.1364 86.7417L75.614 99.1757C76.8177 99.8737 77.4558 100.746 77.5573 101.662C77.6733 102.739 77.0352 103.829 75.614 104.644Z"
              fill="#30BFBF"
            />
            <path
              id="Vector_7"
              d="M77.5425 101.661C77.441 102.563 76.8029 103.45 75.6137 104.134L71.1761 106.722L50.5541 118.749C47.9438 120.261 43.7091 120.261 41.0988 118.749L19.6212 106.315C18.432 105.631 17.7794 104.73 17.6924 103.828C17.7794 102.912 18.432 102.039 19.6212 101.341L44.6808 86.7261C47.2912 85.2137 51.5258 85.2137 54.1361 86.7261L75.6137 99.16C76.1358 99.4654 76.5564 99.7999 76.8609 100.163C77.267 100.629 77.499 101.123 77.5425 101.647V101.661Z"
              fill="url(#paint4_linear_5776_102133)"
            />
            <path
              id="Vector_8"
              d="M58.4721 103.611C58.4721 104.541 57.631 105.632 56.1082 106.577C55.7312 106.81 55.3251 107.028 54.8611 107.232C53.0338 108.061 50.5829 108.642 47.6535 108.642C43.999 108.642 41.0841 107.726 39.1988 106.577C37.6761 105.632 36.835 104.527 36.835 103.611C36.835 101.822 40.0254 99.3352 45.2027 98.7099C45.9713 98.6226 46.7979 98.5645 47.6535 98.5645C54.252 98.5645 58.4576 101.546 58.4576 103.611H58.4721Z"
              fill="#18898E"
            />
            <path
              id="Vector_9"
              style="mix-blend-mode: multiply"
              d="M77.5428 101.662C77.4413 102.563 76.8032 103.451 75.614 104.134L71.1764 106.723H48.2776V100.164H76.8757C77.2818 100.629 77.5138 101.124 77.5573 101.647L77.5428 101.662Z"
              fill="url(#paint5_linear_5776_102133)"
            />
            <path
              id="Vector_10"
              d="M35.269 143.021L11.239 129.118V121.367L35.269 135.27V143.021Z"
              fill="#30BFBF"
            />
            <path
              id="Vector_11"
              d="M54.4116 77.5645V103.436C54.4116 104.73 51.7722 106.606 47.6101 106.606C43.448 106.606 40.8086 104.73 40.8086 103.436V77.5645H54.4116Z"
              fill="url(#paint6_linear_5776_102133)"
            />
            <path
              id="Vector_12"
              d="M47.6101 80.7351C43.4625 80.7351 40.8086 78.8591 40.8086 77.5648C40.8086 76.2705 43.4625 74.3945 47.6101 74.3945C51.7577 74.3945 54.4116 76.2705 54.4116 77.5648C54.4116 78.8591 51.7577 80.7351 47.6101 80.7351Z"
              fill="url(#paint7_linear_5776_102133)"
            />
            <path
              id="Vector_13"
              style="mix-blend-mode: multiply"
              d="M54.4116 77.5645V98.6948C47.9581 95.4955 43.5785 90.4201 40.8086 86.1155V77.5645H54.4116Z"
              fill="url(#paint8_linear_5776_102133)"
            />
            <path
              id="Vector_14"
              d="M85.9393 18.332C85.9393 18.332 85.8813 19.6263 85.6928 21.8659C84.4746 35.6813 78.0067 85.3298 47.6103 85.6206C45.4785 85.6352 43.4627 85.417 41.5629 84.9662C16.3003 79.0619 10.6589 34.7652 9.52779 21.8513C9.33926 19.6263 9.28125 18.332 9.28125 18.332H85.9393Z"
              fill="url(#paint9_linear_5776_102133)"
            />
            <path
              id="Vector_15"
              style="mix-blend-mode: multiply"
              d="M85.9391 18.332C85.9391 18.332 85.8811 19.6263 85.6926 21.8659C84.4744 35.6813 78.0064 85.3298 47.6101 85.6206C45.4782 85.6352 43.4625 85.417 41.5627 84.9662C41.5917 84.9662 41.6062 84.9662 41.6207 84.9662C67.2894 87.5548 78.0064 39.2734 60.4444 40.8731C42.8824 42.4727 23.8991 31.973 23.8991 31.973L23 23.8291L28.2208 18.332H85.9391Z"
              fill="url(#paint10_linear_5776_102133)"
            />
            <path
              id="Vector_16"
              d="M85.9393 18.332C85.9393 18.332 85.8813 19.6263 85.6928 21.8659C81.9947 28.9336 67.9277 36.9466 47.6103 36.9466C27.2929 36.9466 13.2258 28.919 9.52779 21.8513C9.33926 19.6263 9.28125 18.332 9.28125 18.332H85.9393Z"
              fill="#FFDF85"
            />
            <path
              id="Vector_17"
              d="M47.6103 36.2201C24.2039 36.2201 9.28125 25.6185 9.28125 18.3327C9.28125 11.0469 24.2184 0.445312 47.6103 0.445312C71.0022 0.445312 85.9393 11.0469 85.9393 18.3327C85.9393 25.6185 71.0167 36.2201 47.6103 36.2201Z"
              fill="url(#paint11_linear_5776_102133)"
            />
            <path
              id="Vector_18"
              d="M47.625 34.0978C34.0076 34.0978 25.4948 30.0986 21.6228 27.7136C16.9966 24.8632 14.2412 21.3439 14.2412 18.3336C14.2412 11.9058 27.2496 2.58398 47.6105 2.58398C67.9715 2.58398 80.9653 11.9203 80.9653 18.3336C80.9653 21.3294 78.1954 24.8342 73.5693 27.7136C69.7117 30.0986 61.228 34.0978 47.596 34.0978H47.625Z"
              fill="#FFDF85"
            />
            <path
              id="Vector_19"
              d="M80.6317 18.3177C80.6317 21.139 78.0503 24.5129 73.4097 27.3923C72.264 28.1049 71.0023 28.7738 69.6246 29.3992C64.0558 31.9296 56.5582 33.7183 47.6394 33.7183C36.4873 33.7183 27.5685 30.9261 21.8402 27.3923C17.185 24.5129 14.6182 21.1244 14.6182 18.3177C14.6182 12.8642 24.3491 5.25846 40.1418 3.36792C42.5057 3.07707 45.0146 2.93164 47.6249 2.93164C67.7683 2.93164 80.6317 12.0498 80.6317 18.3177Z"
              fill="url(#paint12_linear_5776_102133)"
            />
            <path
              id="Vector_20"
              style="mix-blend-mode: multiply"
              d="M69.61 29.4142C64.0412 31.9446 56.5436 33.7333 47.6248 33.7333C36.4727 33.7333 27.5539 30.9411 21.8256 27.4073C17.1704 24.5278 14.6035 21.1394 14.6035 18.3327C14.6035 12.8792 24.3344 5.27344 40.1272 3.3829C56.9786 6.49502 69.2329 14.2608 71.5242 22.2592C72.2783 24.8914 71.4807 27.2909 69.61 29.4287V29.4142Z"
              fill="url(#paint13_linear_5776_102133)"
            />
            <path
              id="Vector_21"
              d="M68.3771 81.0256C65.7232 81.0256 62.9678 80.2403 60.2704 78.6697C58.5591 77.6808 57.9645 75.4703 58.9652 73.7543C59.9513 72.0383 62.1411 71.442 63.8669 72.4309C66.7383 74.1033 69.2182 74.2779 71.437 72.9836C76.1937 70.235 79.2681 61.1895 79.2681 49.9481C79.2681 46.167 75.3381 43.2294 72.0316 41.4261C70.2913 40.4809 69.8998 38.5176 70.8424 36.7725C71.785 35.0274 73.7138 34.1694 75.4541 35.1146C84.5324 40.0737 86.4322 45.9198 86.4322 49.9481C86.4322 64.1271 82.1685 75.0777 75.019 79.2078C72.9597 80.4003 70.7119 80.9965 68.4061 80.9965L68.3771 81.0256Z"
              fill="url(#paint14_linear_5776_102133)"
            />
            <path
              id="Vector_22"
              d="M27.8731 37.3976L31.6726 47.3447C31.7742 47.5919 32.0207 47.9264 32.2382 48.0864L40.7364 54.2525C40.954 54.4124 40.925 54.616 40.6784 54.7178L34.8631 57.0446C34.6166 57.1464 34.4425 57.4373 34.486 57.699L35.9218 66.9336C35.9653 67.1954 35.8492 67.2535 35.6752 67.0499L28.0181 58.5716C27.8441 58.368 27.4815 58.1935 27.206 58.179L19.8679 57.8008C19.5924 57.8008 19.4184 57.5682 19.4764 57.2919L20.8831 49.8897C20.9266 49.6279 20.8541 49.2353 20.7091 49.0026L14.5167 39.3608C14.3716 39.1282 14.4587 39.0409 14.7052 39.1427L23.1019 42.7783C23.3484 42.8801 23.6675 42.7783 23.827 42.5747L27.438 37.3394C27.583 37.1213 27.7861 37.1358 27.8876 37.3976H27.8731Z"
              fill="url(#paint15_linear_5776_102133)"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5776_102133"
        x1="299.008"
        y1="169.914"
        x2="301.682"
        y2="217.052"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCD24A" />
        <stop offset="1" stop-color="#E5BB2A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5776_102133"
        x1="5.32212"
        y1="119.332"
        x2="89.9998"
        y2="119.332"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#18898E" />
        <stop offset="1" stop-color="#06616F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5776_102133"
        x1="5.35156"
        y1="111.275"
        x2="89.9713"
        y2="111.275"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2CA2A0" />
        <stop offset="1" stop-color="#18898E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5776_102133"
        x1="17.6631"
        y1="108.453"
        x2="77.5712"
        y2="108.453"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#18898E" />
        <stop offset="1" stop-color="#06616F" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5776_102133"
        x1="17.6779"
        y1="102.752"
        x2="77.5425"
        y2="102.752"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2CA2A0" />
        <stop offset="1" stop-color="#18898E" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5776_102133"
        x1="47.915"
        y1="103.451"
        x2="79.8922"
        y2="103.451"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D1D3D4" />
        <stop offset="0.14" stop-color="#DDDFE0" />
        <stop offset="0.41" stop-color="#F0F0F1" />
        <stop offset="0.69" stop-color="#FBFBFB" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5776_102133"
        x1="40.8086"
        y1="92.0925"
        x2="54.4116"
        y2="92.0925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCD24A" />
        <stop offset="1" stop-color="#E5BB2A" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_5776_102133"
        x1="40.8086"
        y1="77.5648"
        x2="54.4116"
        y2="77.5648"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E5BB2A" />
        <stop offset="1" stop-color="#FCD24A" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_5776_102133"
        x1="40.8086"
        y1="88.1369"
        x2="54.4116"
        y2="88.1369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D1D3D4" />
        <stop offset="0.14" stop-color="#DDDFE0" />
        <stop offset="0.41" stop-color="#F0F0F1" />
        <stop offset="0.69" stop-color="#FBFBFB" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_5776_102133"
        x1="9.28125"
        y1="51.9691"
        x2="85.9393"
        y2="51.9691"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCD24A" />
        <stop offset="1" stop-color="#E5BB2A" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_5776_102133"
        x1="35.3993"
        y1="52.0999"
        x2="84.8375"
        y2="49.786"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D1D3D4" />
        <stop offset="0.14" stop-color="#DDDFE0" />
        <stop offset="0.41" stop-color="#F0F0F1" />
        <stop offset="0.69" stop-color="#FBFBFB" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_5776_102133"
        x1="9.28125"
        y1="18.3327"
        x2="85.9393"
        y2="18.3327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E5BB2A" />
        <stop offset="1" stop-color="#FCD24A" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_5776_102133"
        x1="47.5089"
        y1="2.32085"
        x2="47.7422"
        y2="36.9322"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCD24A" />
        <stop offset="1" stop-color="#E5BB2A" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_5776_102133"
        x1="15.7927"
        y1="18.4781"
        x2="67.2606"
        y2="18.6083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D1D3D4" />
        <stop offset="0.57" stop-color="#EDEEEF" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_5776_102133"
        x1="352.226"
        y1="205.284"
        x2="354.087"
        y2="238.211"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCD24A" />
        <stop offset="1" stop-color="#E5BB2A" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_5776_102133"
        x1="329.968"
        y1="221.477"
        x2="356.363"
        y2="236.674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E5B53E" />
        <stop offset="1" stop-color="#CAA239" />
      </linearGradient>
      <clipPath id="clip0_5776_102133">
        <rect width="90" height="148" fill="white" transform="translate(0 0.445312)" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="133"
    height="149"
    viewBox="0 0 133 149"
    fill="none"
  >
    <path
      d="M117.649 53.1223L116.787 53.2288C110.848 54.0078 107.202 55.4489 105.212 57.9653C106.212 58.8828 106.923 60.1907 107.122 61.7169C107.207 62.3842 107.195 63.0443 107.086 63.6655V63.6726C106.667 66.1695 104.829 68.1908 102.408 68.5741C99.3635 69.0497 96.5487 66.7569 96.1053 63.4418C95.9961 62.5705 96.0499 61.724 96.2635 60.9325H96.2569C97.3375 54.1693 101.098 50.4106 105.272 48.2633H105.278C109.228 46.2296 113.547 45.6404 116.313 45.3103C116.373 45.3103 116.428 45.2979 116.477 45.2908L116.66 45.2713C122.43 44.3396 126.439 38.4815 125.608 32.1921C124.777 25.878 119.383 21.4857 113.591 22.3961C113.299 22.4422 113.009 22.4955 112.724 22.5682L112.735 22.6339C112.753 22.7794 112.76 22.9179 112.771 23.0634V23.0829C112.82 23.8549 112.74 24.602 112.535 25.3083C111.915 27.4609 110.217 29.1451 108.021 29.4894C104.982 29.965 102.167 27.6721 101.73 24.3571C101.438 22.1707 102.258 20.0962 103.72 18.8096V18.8025C104.406 18.1813 105.133 17.6205 105.898 17.1254L105.904 17.1183C107.93 15.798 110.188 14.9195 112.553 14.5486C122.325 13.0153 131.414 20.4209 132.815 31.0617C134.224 41.6954 127.422 51.5908 117.649 53.1223Z"
      fill="#F9C710"
    />
    <path
      d="M120.27 43.9279C123.994 41.6616 126.252 37.0582 125.608 32.1904C124.868 26.5896 120.536 22.4937 115.519 22.2896C115.519 22.0181 115.501 21.7484 115.464 21.4768L115.452 21.4112C115.737 21.3384 116.029 21.2852 116.319 21.239C122.114 20.3269 127.505 24.7209 128.336 31.0351C129.125 36.9997 125.557 42.5738 120.269 43.9279H120.27Z"
      fill="#F89F1D"
    />
    <path
      d="M112.771 23.0634C112.771 23.0634 112.68 24.0022 112.535 25.3083C111.915 27.4609 110.217 29.1451 108.021 29.4894C104.982 29.965 102.167 27.6721 101.73 24.3571C101.438 22.1707 102.258 20.0962 103.72 18.8096V18.8025C104.406 18.1813 105.133 17.6205 105.898 17.1254C101.913 22.602 108.779 28.5399 112.771 23.0634Z"
      fill="#F89F1D"
    />
    <path
      d="M107.088 63.6655V63.6726C106.669 66.1695 104.83 68.1908 102.41 68.5741C99.3651 69.0497 96.5503 66.7569 96.107 63.4418C95.9978 62.5705 96.0516 61.724 96.2651 60.9325H96.2586C97.3392 54.1693 101.099 50.4106 105.273 48.2633H105.28C98.9886 54.8685 100.232 69.5715 107.088 63.6672V63.6655Z"
      fill="#F89F1D"
    />
    <path
      d="M15.3508 53.1223L16.213 53.2288C22.1523 54.0078 25.7984 55.4489 27.7885 57.9653C26.7877 58.8828 26.0771 60.1907 25.8782 61.7169C25.7935 62.3842 25.8049 63.0443 25.9141 63.6655V63.6726C26.333 66.1695 28.1715 68.1908 30.5919 68.5741C33.6365 69.0497 36.4513 66.7569 36.8947 63.4418C37.0039 62.5705 36.9501 61.724 36.7366 60.9325H36.7431C35.6625 54.1693 31.9023 50.4106 27.7281 48.2633H27.7216C23.7724 46.2296 19.4532 45.6404 16.6873 45.3103C16.627 45.3103 16.5715 45.2979 16.5226 45.2908L16.3401 45.2713C10.5703 44.3396 6.56075 38.4815 7.39199 32.1921C8.22324 25.878 13.6165 21.4857 19.4092 22.3961C19.7009 22.4422 19.9911 22.4955 20.2763 22.5682L20.2649 22.6339C20.2469 22.7794 20.2404 22.9179 20.229 23.0634V23.0829C20.1801 23.8549 20.26 24.602 20.4653 25.3083C21.0847 27.4609 22.7831 29.1451 24.9785 29.4894C28.0183 29.965 30.8331 27.6721 31.2699 24.3571C31.5617 22.1707 30.7418 20.0962 29.2798 18.8096V18.8025C28.5936 18.1813 27.8667 17.6205 27.1023 17.1254L27.0957 17.1183C25.0698 15.798 22.8124 14.9195 20.4474 14.5486C10.6746 13.0153 1.58632 20.4209 0.184614 31.0617C-1.22361 41.6954 5.57792 51.5908 15.3508 53.1223Z"
      fill="#F9C710"
    />
    <path
      d="M12.7299 43.9279C9.00559 41.6616 6.74819 37.0582 7.39199 32.1904C8.13196 26.5896 12.4642 22.4937 17.481 22.2896C17.481 22.0181 17.499 21.7484 17.5364 21.4768L17.5478 21.4112C17.2626 21.3384 16.9709 21.2852 16.6807 21.239C10.8865 20.3269 5.4948 24.7209 4.66356 31.0351C3.87469 36.9997 7.44252 42.5738 12.7315 43.9279H12.7299Z"
      fill="#F89F1D"
    />
    <path
      d="M20.229 23.0634C20.229 23.0634 20.3203 24.0022 20.4653 25.3083C21.0847 27.4609 22.7831 29.1451 24.9785 29.4894C28.0183 29.965 30.8331 27.6721 31.2699 24.3571C31.5617 22.1707 30.7418 20.0962 29.2798 18.8096V18.8025C28.5936 18.1813 27.8667 17.6205 27.1023 17.1254C31.0874 22.602 24.2206 28.5399 20.229 23.0634Z"
      fill="#F89F1D"
    />
    <path
      d="M25.9124 63.6655V63.6726C26.3313 66.1695 28.1698 68.1908 30.5902 68.5741C33.6349 69.0497 36.4497 66.7569 36.893 63.4419C37.0022 62.5705 36.9484 61.724 36.7349 60.9325H36.7414C35.6608 54.1693 31.9007 50.4106 27.7265 48.2633H27.72C34.0114 54.8685 32.7678 69.5715 25.9124 63.6672V63.6655Z"
      fill="#F89F1D"
    />
    <path
      d="M105.316 0.875H29.1804C26.8355 0.875 24.9345 2.94476 24.9345 5.49795V5.49972C24.9345 8.05291 26.8355 10.1227 29.1804 10.1227H105.316C107.661 10.1227 109.562 8.05291 109.562 5.49972V5.49795C109.562 2.94476 107.661 0.875 105.316 0.875Z"
      fill="#F9C710"
    />
    <path
      d="M38.4822 10.1225H29.182C26.835 10.1225 24.9361 8.05506 24.9361 5.49957C24.9361 4.21828 25.4088 3.06831 26.1798 2.23068C26.9507 1.39127 28.0052 0.876626 29.182 0.876626H38.4822C37.3119 0.876626 36.2492 1.39127 35.4799 2.23068C34.7155 3.07009 34.2363 4.21828 34.2363 5.49957C34.2363 8.05506 36.1416 10.1225 38.4822 10.1225Z"
      fill="#F89F1D"
    />
    <path
      d="M104.302 10.1227L99.4727 51.7416C97.3799 69.7933 83.2814 83.3285 66.5685 83.3285C49.8556 83.3285 35.5875 69.6158 33.6284 51.4257L29.182 10.1244H104.304L104.302 10.1227Z"
      fill="#F9C710"
    />
    <path
      d="M103.769 14.7474H53.3647C45.7075 14.7474 39.7633 22.0234 40.6581 30.3039L42.4803 47.1861C44.4329 65.3762 58.4712 80.5796 75.2884 80.5796C78.3281 80.5796 81.4103 78.6399 84.2186 77.7952C79.086 81.3161 73.0196 83.3303 66.5717 83.3303C49.7496 83.3303 35.5907 69.6176 33.6316 51.4275L29.1853 10.1262H104.307L103.772 14.7492L103.769 14.7474Z"
      fill="#F89F1D"
    />
    <path
      d="M77.7463 81.8609H55.1136C52.9541 81.8609 51.2035 83.767 51.2035 86.1183V86.12C51.2035 88.4713 52.9541 90.3774 55.1136 90.3774H77.7463C79.9058 90.3774 81.6564 88.4713 81.6564 86.12V86.1183C81.6564 83.767 79.9058 81.8609 77.7463 81.8609Z"
      fill="#F9C710"
    />
    <path
      d="M62.2509 90.3774H55.1168C52.9572 90.3774 51.2035 88.4679 51.2035 86.1165C51.2035 84.9399 51.6403 83.8769 52.3493 83.1102C53.0583 82.3383 54.0362 81.8627 55.1152 81.8627H62.2493C61.1686 81.8627 60.1923 82.3383 59.4882 83.1102C58.7792 83.8769 58.3424 84.9399 58.3424 86.1165C58.3424 88.4679 60.0896 90.3774 62.2493 90.3774H62.2509Z"
      fill="#F89F1D"
    />
    <path
      d="M86.2673 46.1781C88.7513 46.8259 89.9525 51.0495 88.9485 55.6086C87.9445 60.1694 85.1166 63.3407 82.6327 62.6912C80.1487 62.0434 80.7176 58.283 81.7216 53.7221C82.7256 49.1613 83.7834 45.5286 86.2673 46.1781Z"
      fill="#7A7A7A"
    />
    <path
      d="M79.0436 71.3142C77.6387 72.4677 75.6421 72.1625 74.5826 70.6345C73.5232 69.1048 74.0122 67.2343 75.4171 66.0807C76.8221 64.9272 78.6085 64.929 79.6679 66.457C80.7273 67.9867 80.447 70.1607 79.0436 71.3142Z"
      fill="#7A7A7A"
    />
    <path d="M73.8329 90.3774H59.6496V122.963H73.8329V90.3774Z" fill="#F9C710" />
    <path d="M74.0106 94.3402L60.3227 100.065V90.3774H73.8345L74.0106 94.3402Z" fill="#F89F1D" />
    <path
      d="M77.9826 120.942H54.4437C51.7441 120.942 49.5557 123.325 49.5557 126.264V126.266C49.5557 129.205 51.7441 131.588 54.4437 131.588H77.9826C80.6822 131.588 82.8706 129.205 82.8706 126.266V126.264C82.8706 123.325 80.6822 120.942 77.9826 120.942Z"
      fill="#F9C710"
    />
    <path
      d="M61.1882 131.586H54.4421C51.743 131.586 49.5524 129.201 49.5524 126.262C49.5524 124.79 50.0984 123.462 50.9834 122.497C51.8685 121.533 53.0941 120.939 54.4421 120.939H61.1882C59.8419 120.939 58.6162 121.533 57.7296 122.497C56.8445 123.46 56.2985 124.79 56.2985 126.262C56.2985 129.201 58.4891 131.586 61.1882 131.586Z"
      fill="#F89F1D"
    />
    <path
      d="M98.6431 145.762C98.6431 146.621 98.322 147.4 97.8053 147.961C97.2903 148.522 96.5731 148.873 95.7859 148.873H34.2836C32.7058 148.873 31.4329 147.48 31.4329 145.762C31.4329 141.846 32.8884 138.305 35.2419 135.743C36.673 134.177 38.4398 132.981 40.4103 132.282C41.6784 131.833 43.0377 131.588 44.4443 131.588H85.6235C92.813 131.588 98.6415 137.936 98.6415 145.762H98.6431Z"
      fill="#F9C710"
    />
    <path
      d="M62.2509 148.873H34.2852C32.7075 148.873 31.4345 147.48 31.4345 145.762C31.4345 141.846 32.89 138.305 35.2436 135.743C36.6746 134.177 38.4414 132.981 40.412 132.282C41.103 143.697 50.0153 147.764 62.2509 148.875V148.873Z"
      fill="#F89F1D"
    />
  </svg>
</template>
